module.exports = __webpack_public_path__ + "assets/images/invisible-asia/4-thailand.jpg?v=37d53ffe";